var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getInviteInfo)?_c('div',[_c('invite-code-header',{attrs:{"page-name":"招待コード"}}),_vm._v(" "),_c('invite-code-qr'),_vm._v(" "),_c('invite-code-share')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }